import { apiService } from '../../shared/services/apiService';
import { SolutionType } from '../../shared/constants/user-info/solutionType';
import { DailyInsight } from '../interfaces/DailyInsights';

export const insightsWidgetService = {
  async getDailyInsights(solutionType: SolutionType) {
    const resp = await apiService.get<DailyInsight>('/api/home-page/insight', {
      params: { solutionType },
    });

    return resp.data;
  },
};
